export function formatNumber(value: number): string {
  if (value >= 1000000) {
    return parseFloat((value / 1000000).toFixed(1)).toString() + "M";
  } else if (value >= 1000) {
    return parseFloat((value / 1000).toFixed(1)).toString() + "K";
  }
  return parseFloat(value.toFixed(1)).toString();
}

export function formatManaNumber(value: number): string {
  const flooredValue = Math.floor(value);

  if (flooredValue >= 1000000) {
    return Math.floor(flooredValue / 1000000).toString() + "M";
  } else if (flooredValue >= 1000) {
    return Math.floor(flooredValue / 1000).toString() + "K";
  }
  return flooredValue.toString();
}

export function formatManaRate(dailyRate: number): {
  rate: string;
  unit: string;
} {
  const hourlyRate = dailyRate / 24;
  const minuteRate = dailyRate / (24 * 60);

  if (hourlyRate >= 1) {
    return {
      rate: parseFloat(hourlyRate.toFixed(1)).toString(),
      unit: "hour",
    };
  } else if (minuteRate >= 1) {
    return {
      rate: parseFloat(minuteRate.toFixed(1)).toString(),
      unit: "min",
    };
  } else {
    return {
      rate: parseFloat(dailyRate.toFixed(1)).toString(),
      unit: "day",
    };
  }
}
